import { KeyboardArrowUp } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { useStyles } from './style';

/**
 * @name ScrollToTop
 * @description Renders typography element that scrolls page to the top
 * @returns {JSX.Element} ReactElement
 */
const ScrollToTop = () => {
  const theme = useTheme();
  const style = useStyles(theme);
  return (
    <Box
      sx={style.scrollBox}
      tabIndex={0}
      aria-label='back to the top of the page main navigation eir logo'
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();

          // 1. Scroll to top visually
          window.scrollTo({ top: 0 });

          // 2. Prepare focus for NEXT Tab (not now)
          const target = document.querySelector('a[component="a"][href="https://www.eir.ie"]');
          if (!target) return;

          /**
           * @description  Handles the next Tab key press and moves focus.
           * @param {KeyboardEvent} event - The keydown event
           */
          const onNextTab = event => {
            if (event.key === 'Tab') {
              event.preventDefault(); // consume this Tab
              target.focus(); // move focus now
              document.removeEventListener('keydown', onNextTab, true);
            }
          };

          document.addEventListener('keydown', onNextTab, true);
        }
      }}
      onClick={() => window.scrollTo({ top: 0 })}
    >
      <KeyboardArrowUp />
      <Typography variant='subtitle1' sx={style.scrollToTop}>
        Back to top
      </Typography>
    </Box>
  );
};

export default ScrollToTop;
